import layoutHeaderAside from '@/layouts/HeaderAside'

const meta = {
  auth: true
}
export default {
  path: '/container',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: '/container/containerPreOrder',
      name: 'containerPreOrder',
      component: () => import('@/pages/container/containerPreOrder/index.vue'),
      meta: {
        ...meta,
        title: '空箱预定',
        requireAuth: true
      }

    },
    {
      path: '/container/containerInvoice',
      name: 'containerInvoice',
      component: () => import('@/pages/container/containerInvoice/index.vue'),
      meta: {
        ...meta,
        title: '填写运单',
        requireAuth: true
      }
    },
  ]
}
